import { formatDistance, format, isToday, isYesterday, differenceInMinutes } from "date-fns";

export function formatAsRelativeDate(date: Date | string) {
    return formatDistance(new Date(date), new Date(), {
        addSuffix: true
    })
}

/**
 * Gmail/Outlook-style date formatting for email threads.
 * Avoids ambiguous phrasing like "last Monday".
 */
export function formatMessageDate(date: Date | string): string {
    const d = new Date(date);
    const now = new Date();
    const diffMins = differenceInMinutes(now, d);

    if (diffMins < 1) return 'just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (isToday(d)) return format(d, 'h:mm a');
    if (isYesterday(d)) return `Yesterday, ${format(d, 'h:mm a')}`;
    if (d.getFullYear() === now.getFullYear()) return format(d, 'MMM d, h:mm a');
    return format(d, 'MMM d, yyyy, h:mm a');
}

/** Full datetime string for use in title/tooltip attributes. */
export function formatMessageDateFull(date: Date | string): string {
    return format(new Date(date), 'EEEE, MMMM d, yyyy, h:mm:ss a');
}